module.exports = __webpack_public_path__ + "static/media/frozen-root-beer-dt-back-up-fr.3a837004.jpg";